(() => {
  const init = () => {
    if (!document.body.classList.contains('product-ergo-cushion')) return;

    const productInfo = document.querySelector('product-info');
    const sticky = document.querySelector('[data-calora-safe-sticky]');
    const stickyButton = document.querySelector('[data-calora-safe-add]');
    const offer = document.querySelector('#calora-buy-area');
    if (!productInfo || !sticky || !stickyButton) return;

    const originalButton = () => productInfo.querySelector('.product-form__submit:not([disabled])');

    document.querySelectorAll('#MainContent a[href="#"], #MainContent a[href="#calora-buy-area"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        offer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    sticky.hidden = false;
    stickyButton.addEventListener('click', () => {
      const button = originalButton();
      if (button) button.click();
      else offer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const buyArea = productInfo.querySelector('.product-form__buttons') || productInfo;
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.12 });
    observer.observe(buyArea);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
